import React, { useEffect, useState } from "react";
import { useAppDispatch } from "../../../../lib/hook";
import { FormProps, useForm } from "antd/es/form/Form";
import { ITripPayload } from "../../../../lib/features/trips/trips.constant";
import { DatePicker, Form, Input, InputNumber, Modal, Switch } from "antd";
import dayjs from "dayjs";
import { onAddTrip } from "../../../../lib/features/trips/trips.thunk";
import { localeDateTimePicker } from "../../../../function/datePicker.locale";

interface ModalAddTripProps {
  visible: boolean;
  onClose: () => void;
}

const ModalAddTrip: React.FC<ModalAddTripProps> = (
  props: ModalAddTripProps
) => {
  const dispatch = useAppDispatch();
  const { onClose, visible } = props;
  const [loading, setLoading] = useState(false);
  const [form] = useForm();
  const onFinish: FormProps<ITripPayload>["onFinish"] = async (values) => {
    setLoading(true);
    const departureAtMidnight = dayjs(values.departureDate)
      .startOf("day")
      .format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
    const payload = { ...values, departureDate: departureAtMidnight };
    await dispatch(onAddTrip(payload)).then((result) => {
      if (result?.type.includes("fulfilled")) {
        form.resetFields();
        onClose && onClose();
        setLoading(false);
      }
    });

    setLoading(false);
  };
  useEffect(() => {
    if (visible) {
      return () => {
        form.resetFields();

        setLoading(false);
      };
    }
      // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [visible]);
  const handleDateChange = (value: number | null) => {
    if (value && value > 0) {
      form.setFieldValue("numberOfNight", Math.max(value - 1, 0));
    } else {
      form.setFieldValue("numberOfNight", 0);
    }
  };
  return (
    <Modal
      loading={loading}
      title="Thêm chuyến đi"
      open={visible}
      onCancel={onClose}
      onOk={() => form.submit()}
      confirmLoading={loading}
    >
      <Form
        disabled={loading}
        layout="vertical"
        form={form}
        onFinish={onFinish}
        autoComplete="off"
        className="mt-3"
      >
        <Form.Item<ITripPayload>
          label="Tên chuyến đi"
          name="name"
          rules={[{ required: true, message: "Mời điền tên chuyến đi" }]}
          style={{ marginBottom: 8 }}
        >
          <Input placeholder="Nhập tên chuyến đi" />
        </Form.Item>

        <Form.Item<ITripPayload>
          label="Số ngày"
          name="numberOfDate"
          rules={[
            { required: true, message: "Vui lòng nhập số ngày" },
            { type: "number", min: 1, message: "Số ngày phải lớn hơn 0" },
          ]}
          style={{ marginBottom: 8 }}
        >
          <InputNumber
            min={1}
            style={{ width: "100%" }}
            onChange={handleDateChange}
          />
        </Form.Item>

        <Form.Item<ITripPayload>
          label="Số đêm"
          name="numberOfNight"
          rules={[
            { required: true, message: "Vui lòng nhập số đêm" },
            ({ getFieldValue }) => ({
              validator(_, value) {
                const numDate = getFieldValue("numberOfDate");
                if (value <= numDate) return Promise.resolve();
                return Promise.reject(
                  new Error("Số đêm phải nhỏ hơn hoặc bằng số ngày")
                );
              },
            }),
          ]}
          style={{ marginBottom: 8 }}
        >
          <InputNumber min={0} style={{ width: "100%" }} />
        </Form.Item>

        <Form.Item<ITripPayload>
          label="Ngày khởi hành"
          name="departureDate"
          rules={[{ required: true, message: "Vui lòng chọn ngày khởi hành" }]}
          style={{ marginBottom: 8 }}
        >
          <DatePicker
            style={{ width: "100%" }}
            format="DD/MM/YYYY"
            placeholder="Chọn ngày khởi hành"
            locale={localeDateTimePicker as any}
          />
        </Form.Item>
        <Form.Item<ITripPayload>
          label="Khởi hành ban đêm"
          name="isNightDeparture"
          valuePropName="checked"
          style={{ marginBottom: 8 }}
        >
          <Switch checkedChildren="Có" unCheckedChildren="Không" />
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default ModalAddTrip;
